export default "__VITE_ASSET__BPe2sDop__"